var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 73.21 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#040505;}.cls-4{fill:#e02825;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#d8006c;}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -94.33,
    y: -83.18,
    width: 257.81,
    height: 235.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -48.97,
    y: -69.7,
    width: 167.04,
    height: 208.83,
    transform: "translate(-10.97 52.78) rotate(-66.79)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    className: "cls-3",
    d: "M61.93,28.26c-7.5,19.63-26.5,34.63-48.8,27.57-1.51-.08-3.15-.27-4.78-.45S5.06,55,3.44,54.89a20.55,20.55,0,0,1,1-4.91,40.55,40.55,0,0,1,1.9-4.58c9.13-12.51,16.13-29.51,32-35.93a27.57,27.57,0,0,1,4.06-2.22c5.85-2.61,12.1-3.86,19.1-1.36,8,3,9,13,3.56,18.91a31.41,31.41,0,0,1-3.06,3.46M70.83,5.1a36.12,36.12,0,0,0-34.52.1,31.33,31.33,0,0,0-4.9,3.13c-12,7.56-20,19.56-26.85,31.89-.9,1.77-1.7,3.38-2.35,4.94-1.93,4.61-2.4,8.73.23,11.73,3,3.38,7.54,4.92,12.77,5.39a44.75,44.75,0,0,0,5.43.12c17.8-.51,34.8-5.51,39.94-24.95,1.15-1.85,2.3-3.58,3.44-5.29,4.52-6.86,8.61-13.95,8.81-22.63a7.81,7.81,0,0,0-2-4.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-4",
    d: "M65.77,9.52A34.58,34.58,0,0,0,43.06,7.68a23.58,23.58,0,0,0-5,1.86C22.44,16.89,12.44,30.89,7.37,47.3a40.89,40.89,0,0,1-1.8,4.52c-.67,1.4-1.37,2.76-2.14,4.07,1.63.25,3.25.47,4.88.65s3.21.31,4.74.34c22.38,4,39.38-7,46.43-27.88.91-1.72,1.85-3.3,2.8-4.86,1.9-3.13,3.83-6.34,5.72-9.7.35-2.52-.22-4.4-2.23-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-3",
    d: "M43,17.11c-14.6,1.78-22.6,17.78-26.6,30.78,5-9,9-18,16-25,4-4,11-6,14,0,2,4,1,7,0,11-6,12-18,14-30,14,6-1,13,4,18,0,9-6,23-17,13.54-29.41A21.84,21.84,0,0,0,43,17.11"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-6",
    d: "M43.32,15.14C27.44,17.89,16.44,32.89,13.44,47.89c9-13,23-42,37-26,6,7-7,18-14,26,8-8,21-17,16-31a12.78,12.78,0,0,1-3.69-.6,32.61,32.61,0,0,0-5.43-1.16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    className: "cls-3",
    d: "M41.43,11.16c-16,5.73-29,21.73-31,38.73,8-16,17-36,37.36-36.63a19,19,0,0,1,5.28,1,24.14,24.14,0,0,1,5.36,2.6A23.75,23.75,0,0,0,55.74,21c-6.31,19.9-23.31,35.9-45.31,29.9,21,8,42-3,47.39-25.12a53.58,53.58,0,0,1,2.69-5.22c1-1.6,1.92-3.16,2.92-4.66a84.74,84.74,0,0,1-12.8-3.5c-1.45-.48-3-1-4.54-1.46a20.76,20.76,0,0,0-4.66.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-6",
    d: "M43.36,19.2C32.44,21.89,16.44,34.89,24.44,44.89c6,7,18-6,23-15,1-3,0-7-2.4-10.2a4.37,4.37,0,0,0-1.69-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-6",
    d: "M58.05,28.63c-5.61,8.26-9.61,18.26-18.61,23.26-10,4-33,7-30-5A59.29,59.29,0,0,1,41,8.64a24.32,24.32,0,0,1,4.07-1.28,20.55,20.55,0,0,1,4.35-.47c5,1,11,1,14,7,2,5,0,8-2.67,11.57-.8.92-1.72,1.93-2.72,3.17m9-19.57c-9.16-6.35-18.84-6-27.65-2.42a29.85,29.85,0,0,0-4.87,2.5C22.44,17.89,11.44,27.89,5.77,42a27.73,27.73,0,0,0-1.36,4.64,7.83,7.83,0,0,0,2,7.3,13.62,13.62,0,0,0,3,2.26,19.25,19.25,0,0,0,3.71,1.58c22.27,6.16,39.27-5.84,46.17-25.52,1-1.69,2-3.15,3-4.63,2.94-4.36,5.42-9,6.23-14.53a6.58,6.58,0,0,0-1.51-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-4",
    d: "M43.89,23.51C32.44,21.89,19.44,34.89,24.44,42.89c7,9,18-10,20.87-17.81a3.84,3.84,0,0,0-1.42-1.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-7",
    d: "M42.67,29c-3.23-5.07-9.23-4.07-12.23-.07-3,5-8,11-6,14,6,6,13-6,17.9-11a5.52,5.52,0,0,0,.33-2.9m-3.36,5.31c-2.87,5.62-8.87,8.62-14.87,9.62,3-7,5-18,15-18,2,1,2,4,1.59,5.58a10.35,10.35,0,0,1-1.72,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-7",
    d: "M38.93,28c-5.49.87-8.49,3.87-10.49,7.87,0,2,1,4,3,4,4-2,8-5,8.18-9.6A2.6,2.6,0,0,0,38.93,28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-3",
    d: "M36.28,28.82c-5.84.07-7.84,6.07-8.84,11.07,1-2,1-4,2-6,1-1,3-6,5,0,2,4-5,3-7,6,5-2,10-4,10.17-10.43a2,2,0,0,0-1.33-.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    className: "cls-3",
    d: "M36.43,32.31a3,3,0,0,0-3-1.42c-2,2-4,4-1,6,2,0,0-5,3.7-4.13a1.74,1.74,0,0,0,.29-.45"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement1);
export default __webpack_public_path__ + "static/media/Element1.f431517fdcbcaaf46b1d270c45ed9738.svg";
export { ForwardRef as ReactComponent };